import { ArbitraryAreaChart1, ArbitraryButton1, ArbitraryComposedChart1, ArbitraryLineChart1, ArbitraryMenu, ArbitraryParagraph, ArbitraryParagraphs, ArbitraryWords, JsonViewer } from "./ArbitraryContent"
import { HDockLayout } from "./HDockLayout";
import { TabControl } from "./TabControl";
import { VDockLayout } from "./VDockLayout"
import { VScroller } from "./VScroller";
import { VHScroller } from "./VHScroller";
import { FlexLayout } from "./FlexLayout";
import { PipelineContext } from "./PipelineContext";
import { StyleProperties } from "./_Properties";
import { DivLayout } from "./DivLayout";
//import { Configurator } from "../configs/ConfiguratorOld";
import { ViewConfigWrapper } from "../configs/ViewConfigWrapper";
import { PipelineComputeContext } from "./PipelineComputeContext";
import { ComputeButton } from "./ComputeButton";
import { CustomRender } from "./CustomRender";
import { ComputeJsContext } from "./ComputeJsContext";
import { DataTableContent } from "./DataTableContent";
import { LineChart1 } from "./Charts";
import { DropDown } from "./DropDown";
import { CopyStateButton } from "./CopyStateButton";
import { SelectCGroupsInput } from "../filter-books/SelectCGroupsInput";
import { ZSunburst } from "./ZSunburst";
import { ToggleStateButton } from "./ToggleStateButton";


export const getContentTypes = () => {

    const ctypes = [
        
        { 
            id: "_arb_words",  
            generator: (p) => <ArbitraryWords {...p} />,
            properties: [
                StyleProperties.margin,
                StyleProperties.width,
                StyleProperties.minWidth,
                StyleProperties.maxWidth,
                StyleProperties.height,
                StyleProperties.minHeight,
                StyleProperties.maxHeight,
                { "name": "style.border", "type": "string" },
                { "name": "style.padding", "type": "string" },
                { "name": "words", "type": "string" },
            ]
        },
        { 
            id: "_arb_pp",
            generator: (p) => <ArbitraryParagraph {...p} />,
            properties: [
                StyleProperties.width,
                StyleProperties.minWidth,
                StyleProperties.maxWidth,
                StyleProperties.height,
                StyleProperties.minHeight,
                StyleProperties.maxHeight,                
            ]
        },
        { 
            id: "_arb_pps",
            generator: (p) => <ArbitraryParagraphs {...p} />,
            properties: [
                StyleProperties.width,
                StyleProperties.height
            ]
        },
        { 
            id: "_arb_linechart1",
            generator: (p) => <ArbitraryLineChart1 {...p} />,
            properties: [
                StyleProperties.width,
                StyleProperties.height,
            ]
        },
        {
            id: "dynamic-linechart1",
            generator: (p) => <LineChart1 {...p} />,
            properties: [
                { "name": "render", "type": "render-syntax" }
            ]
        },
        { 
            id: "_arb_areachart1",
            generator: (p) => <ArbitraryAreaChart1 {...p} />,
            properties: [
                StyleProperties.width,
                StyleProperties.height,
            ]
        },
        { 
            id: "_arb_cchart1",
            generator: (p) => <ArbitraryComposedChart1 {...p} />,
            properties: [
                StyleProperties.width,
                StyleProperties.height,
            ]
        },
        { 
            id: "_arb_zsunburst",
            generator: (p) => <ZSunburst {...p} />,
            properties: [
                StyleProperties.width,
                StyleProperties.height,
            ]
        },
        {
            id: "_menu",       
            generator: (p) => <ArbitraryMenu {...p} />,
            properties: [
                StyleProperties.width,
                StyleProperties.minWidth,
                StyleProperties.maxWidth,
                StyleProperties.height,
                StyleProperties.minHeight,
                StyleProperties.maxHeight,
            ]
        },
        //{ id: "_mi",   categoryLabel: "Content", label: "Menu Item", generator: (p) => <ArbitraryMenuItem {...p} /> },
        { 
            id: "_btn",  
            generator: (p) => <ArbitraryButton1 {...p} />,
            properties: [
                StyleProperties.width,
                StyleProperties.height
            ]
        },
        //{ id: "_md",   categoryLabel: "Content", label: "Markdown", generator: (p) => <Markdown1 {...p} /> },

        { 
            id: "tabcontrol",    
            generator: (args) => <TabControl {...args} />,
            svgPath: "M0 0v16h16v-13h-5v-3h-10zM1 4v11h14v-11h-14zM1 1v3h4v-3zM6 1v2h4v-2z",
            //svgPath: "M0 0 v16h16v-16h-16z"
            properties: [
                StyleProperties.width,
                StyleProperties.height,
                { name: "align", type: "select", options: ["left", "center", "right"] }
            ]
        },
        
        {
            id: "div",
            generator: (args) => <DivLayout {...args} />,
            properties: [
                StyleProperties.width,
                StyleProperties.minWidth,
                StyleProperties.maxWidth,
                StyleProperties.height,
                StyleProperties.minHeight,
                StyleProperties.maxHeight,
                StyleProperties.background
            ]
        },
        { 
            id: "flex",  
            //categoryLabel: "Layout", 
            //label: "Flex", 
            //jdata: { flexDirection: "row" },
            properties: [
                { "name": "style.margin", "type": "string" },
                StyleProperties.background,
                StyleProperties.width,
                StyleProperties.minWidth,
                StyleProperties.maxWidth,
                StyleProperties.height,
                StyleProperties.minHeight,
                StyleProperties.maxHeight,
                { "name": "style.flexDirection", "type": "flex.flexDirection" },
                { "name": "style.flexWrap", "type": "flex.flexWrap" },
                { "name": "style.alignItems", "type": "flex.alignItems" },
                { "name": "style.alignContent", "type": "flex.alignContent" },
                { "name": "style.justifyContent", "type": "flex.justifyContent" },
                { "name": "style.border", "type": "string" },
                { "name": "style.padding", "type": "string" },
                { "name": "style.gap", "type": "string" },
            ],
            childProperties: [
                { "name": "style.flexGrow", "type": "string" },
                { "name": "style.flexShrink", "type": "string" },
                { "name": "style.flexBasis", "type": "string" },
            ],
            generator: (args) => <FlexLayout direction="row" {...args} />,
            //svgPath: "M0 0h4v16h-4zm1 1h2v14h-2zM6 0h4v16h-4zm1 1h2v14h-2zM12 0h4v16h-4zm1 1h2v14h-2z" 
        },

        { 
            id: "vstack",
            categoryLabel: "Layout",
            label: "VStack (Flex)",
            jdata: { flexDirection: "column" },
            generator: (args) => <FlexLayout direction="column" {...args} />,
            svgPath: "M0 0v4h16v-4zm1 1v2h14v-2zM0 6v4h16v-4zm1 1v2h14v-2zM0 12v4h16v-4zm1 1v2h14v-2z",
            properties: [
                StyleProperties.width,
                StyleProperties.minWidth,
                StyleProperties.maxWidth,
                StyleProperties.height,
                StyleProperties.minHeight,
                StyleProperties.maxHeight
            ]
        },

        { 
            id: "hdock",   
            categoryLabel: "Layout", 
            label: "HDock Layout", 
            generator: (args) => <HDockLayout {...args} />,
            svgPath: "M0 0v16h16v-16h-16zM1 1h2v14h-2zM4 1h8v14h-8zM13 1h2v14h-2z",
            properties: [
                StyleProperties.margin,
                StyleProperties.width,
                StyleProperties.minWidth,
                StyleProperties.maxWidth,
                StyleProperties.height,
                StyleProperties.minHeight,
                StyleProperties.maxHeight
            ]
        },
        { 
            id: "vdock",   
            categoryLabel: "Layout", 
            label: "VDock Layout", 
            generator: (args) => <VDockLayout {...args} />, 
            svgPath: "M0 0v16h16v-16h-16zM1 1v2h14v-2zM1 4v8h14v-8zM1 13v2h14v-2z",
            properties: [
                StyleProperties.margin,
                StyleProperties.width,
                StyleProperties.minWidth,
                StyleProperties.maxWidth,
                StyleProperties.height,
                StyleProperties.minHeight,
                StyleProperties.maxHeight
            ]
        },
        { 
            id: "vscroll", 
            categoryLabel: "Layout", 
            label: "VScroll", 
            generator: (args) => <VScroller {...args} />,
            svgPath: "M0 0h16v16h-16zM1 1h11v14h-11zM13 1h2v1h-2zM13 8h2v5h-2zM13 14h2v1h-2z",
            properties: [
                StyleProperties.width,
                StyleProperties.height
            ]
        },
        { 
            id: "vhscroll",
            categoryLabel: "Layout",
            label: "VHScroll",
            generator: (args) => <VHScroller {...args} />,
            svgPath: "M0 0h16v16h-16zM1 1h11v11h-11zM13 1h2v1h-2zM13 6h2v6h-2zM1 13v2h1v-2zM6 13v2h6v-2zM13 13v2h2v-2z",
            properties: [
                StyleProperties.width,
                StyleProperties.height
            ]
        },
        { 
            id: "context-pipeline", 
            categoryLabel: "Compute", 
            label: "DataSource Pipeline", 
            generator: (args) => <PipelineContext {...args} />,
            properties: [
                StyleProperties.width,
                StyleProperties.height
            ]
        },
        { 
            id: "configurator",
            //categoryLabel: "Simulator",
            generator: (args) => <ViewConfigWrapper {...args} />,
            properties: [
                StyleProperties.width,
                StyleProperties.height,
                { name: "layout", type: "select", options: ["tiles", "rows"] },
                { name: "attsId", type: "data-source" },
                { name: "selectionId", type: "selection" },
                { name: "compSelectionId", type: "selection" },
                { name: "aggAttNameState", type: "selection" },
                { name: "showAvailability", type: "select", options: ["yes", "no"] }
                //{ name: "compute", type: "crsyntaxv2" },
            ]
        },

        { 
            id: "context-js", 
            //categoryLabel: "Compute", 
            //label: "Javascript", 
            generator: (args) => null,
            properties: [
                StyleProperties.width,
                StyleProperties.height
            ],

        },

        {
            id: "context-pipeline",
            generator: (p) => <PipelineComputeContext {...p} />,
            svgPath: "M15,4C15.2765626907349,4 15.5265626907349,4.11171865463257 15.7074222564697,4.29257822036743 15.8882808685303,4.47343730926514 16,4.72343730926514 16,5L16,13C16,13.2765626907349 15.8882808685303,13.5265626907349 15.7074222564697,13.7074222564697 15.5265626907349,13.8882808685303 15.2765626907349,14 15,14 14.7234373092651,14 14.4734373092651,13.8882818222046 14.2925777435303,13.7074222564697 14.1117191314697,13.5265626907349 14,13.2765626907349 14,13L14,5C14,4.72343730926514 14.1117191314697,4.47343730926514 14.2925777435303,4.29257822036743 14.4734373092651,4.11171865463257 14.7234373092651,4 15,4z M1,4C1.55312502384186,4,2,4.44687509536743,2,5L2,13C2,13.2765626907349 1.88828122615814,13.5265626907349 1.70742177963257,13.7074222564697 1.52656245231628,13.8882808685303 1.27656245231628,14 1,14 0.446875065565109,14 5.00000005843049E-08,13.5531253814697 5.00000005843049E-08,13L5.00000005843049E-08,5C5.00000005843049E-08,4.44687509536743,0.446875065565109,4,1,4z M8,3.50624990463257L9,3.63124990463257 9,5 13,5 13,13 3,13 3,5 7,5 7,3.63124990463257 8,3.50624990463257z M8,5.16773219771949E-08C8.27656269073486,5.96046447753906E-08 8.52656269073486,0.111718833446503 8.70742225646973,0.292578279972076 8.88828086853027,0.473437607288361 9,0.723437607288361 9,1L9,1.375 12,1C12.2765626907349,1 12.5265626907349,1.11171865463257 12.7074222564697,1.29257822036743 12.8882808685303,1.47343754768372 13,1.72343754768372 13,2 13,2.55312490463257 12.5531253814697,3 12,3L8,2.5 4,3C3.44687509536743,3 3,2.55312490463257 3,2 3,1.72343754768372 3.11171865463257,1.47343754768372 3.29257822036743,1.29257822036743 3.47343754768372,1.11171865463257 3.72343754768372,1 4,1L7,1.375 7,1C7,0.723437607288361 7.11171865463257,0.473437607288361 7.29257822036743,0.292578279972076 7.47343730926514,0.111718833446503 7.72343730926514,5.96046447753906E-08 8,5.16773219771949E-08z",
            properties: [
                { "name": "pipeline", "type": "cpipeline" },
                { "name": "recalc", "type": "select", "options": ["auto", "manual"] }
            ]
        },

        {
            id: "context-js",
            generator: (p) => <ComputeJsContext {...p} />,
            svgPath: "M7.20357179641724,7.34642934799194L7.20357179641724,12.457142829895C7.20357179641724,12.8339281082153 7.125,13.07053565979 6.98482179641724,13.2129459381104 6.84464311599731,13.355357170105 6.64285755157471,13.4035711288452 6.39642906188965,13.4035711288452 5.8785719871521,13.4035711288452 5.6642861366272,13.0500001907349 5.4285717010498,12.6321430206299L4.20357131958008,13.3714284896851C4.38214302062988,13.7482147216797 4.64553594589233,14.0919647216797 5.01473236083984,14.3415184020996 5.38392877578735,14.5910711288452 5.85892868041992,14.7464284896851 6.46071434020996,14.7464284896851 7.79285717010498,14.7464284896851 8.70714378356934,14.0357141494751 8.70714378356934,12.4785709381104L8.70714378356934,7.34642934799194 7.20357179641724,7.34642934799194z M12.1785717010498,7.26071500778198C11.5089292526245,7.26071500778198 10.9589290618896,7.47500085830688 10.5763397216797,7.83035707473755 10.1937503814697,8.18571376800537 9.97857189178467,8.68214225769043 9.97857189178467,9.24642848968506 9.97857189178467,10.4714288711548 10.6964292526245,11.0535717010498 11.7821435928345,11.5142860412598L12.1571435928345,11.6750001907349C12.8464298248291,11.9785709381104 13.2535724639893,12.1607141494751 13.2535724639893,12.6750001907349 13.2535724639893,12.8910713195801 13.1535720825195,13.0767860412598 12.9758930206299,13.2084827423096 12.7982149124146,13.3401794433594 12.542857170105,13.4178581237793 12.2321434020996,13.4178581237793 11.8625001907349,13.4178581237793 11.5723218917847,13.3205366134644 11.3343753814697,13.1575899124146 11.0964288711548,12.9946432113647 10.9107151031494,12.7660713195801 10.75,12.5035715103149L9.52500057220459,13.21071434021C9.9642858505249,14.082142829895 10.8678569793701,14.7464284896851 12.2642860412598,14.7464284896851 12.7986602783203,14.7464284896851 13.2823104858398,14.6419649124146 13.6781320571899,14.4401931762695 14.0739545822144,14.2384214401245 14.3819484710693,13.939341545105 14.5650119781494,13.5501117706299 14.6870546340942,13.2906246185303 14.7535724639893,12.9910717010498 14.7535724639893,12.6535711288452 14.7535724639893,12.0250005722046 14.5741081237793,11.5705366134644 14.2348222732544,11.2049112319946 13.8955364227295,10.8392868041992 13.3964290618896,10.5625009536743 12.7571439743042,10.2892866134644L12.3821439743042,10.1285715103149C12.0589294433594,9.98750019073486 11.8276796340942,9.87142944335938 11.6772327423096,9.734375 11.5267858505249,9.59732151031494 11.457142829895,9.43928623199463 11.457142829895,9.2142858505249 11.457142829895,9.03214263916016 11.5267858505249,8.87142848968506 11.6513395309448,8.75624942779541 11.7758932113647,8.64107131958008 11.9553575515747,8.5714282989502 12.1750001907349,8.5714282989502 12.3910722732544,8.5714282989502 12.5687503814697,8.61696434020996 12.7245540618896,8.72008895874023 12.8803577423096,8.82321453094482 13.0142860412598,8.98392868041992 13.1428575515747,9.2142858505249L14.3142862319946,8.4642858505249C14.0678577423096,8.02857112884521 13.77321434021,7.72767877578735 13.4205360412598,7.53571462631226 13.0678577423096,7.34375047683716 12.6571435928345,7.26071500778198 12.1785717010498,7.26071500778198z M2.50001139789902E-08,0L16,0 16,16.0000019073486 2.50001139789902E-08,16.0000019073486 2.50001139789902E-08,0z",
            properties: [
                { "name": "syntax", "type": "syntax" },
                { "name": "recalc", "type": "select", "options": ["auto", "manual"] }
            ]
        },

        { 
            id: "btn-calc",
            generator: (p) => <ComputeButton {...p} />,
            properties: [
            ]
        },

        { 
            id: "btn-copy-state",
            generator: (p) => <CopyStateButton {...p} />,
            properties: [
                { name: "selectionFrom", type: "selection" },
                { name: "selectionTo", type: "selection" },
                { name: "recalc", type: "select", "options": ["yes", "no"] }
            ]
        },

        {
            id: "json-viewer",
            generator: (args) => <JsonViewer {...args} />,
            properties: [

            ]
        },

        {
            id: "data-table",
            generator: (args) => <DataTableContent {...args} />,
            properties: [

            ]
        },


        {
            id: "custom-render",
            generator: (args) => <CustomRender {...args} />,
            properties: [
                { "name": "render", "type": "render-syntax" },
            ]
        },

        { 
            id: "bound-drop-down",
            generator: (p) => <DropDown {...p} />,
            properties: [
                { "name": "collection", "type": "collection" },
                { "name": "selection", "type": "selection" },
                { "name": "format", "type": "select", "options": ["dropdown", "buttons"] }
            ]
        },

        { 
            id: "bound-toggle-button",
            generator: (p) => <ToggleStateButton {...p} />,
            properties: [
                { "name": "selection", "type": "selection" },
            ]
        },

        {
            id: "select-cgroups",
            generator: (p) => <SelectCGroupsInput {...p} />,
            properties: [
                { "name": "filtersId", "type": "data-source" },
                { "name": "selectionId", "type": "selection" }
            ]
        }

        //{ id: "grid1",   categoryLabel: "Layout", label: "Grid Layout", generator: (args) => <GridLayout {...args} /> },
        //{ id: "grid2",   categoryLabel: "Layout", label: "Grid Layout filled cells", generator: (args) => <GridLayout2 {...args} /> },
    ]
    return ctypes;
    
}

export const getCreators = () => {

    const templates = [
        { 
            ctype: "_arb_words",  
            categoryLabel: "Dummy Content",
            label: "Words",
            createItem: () => {
                const strs = [
                    "Lorem ipsum",
                    "dolor sit amet",
                    "consectetur adipiscing elit.",
                    "Donec tincidunt arcu nec",
                    "tortor dictum ultricies",
                    "Nunc vehicula",
                    "nisi in interdum",
                    "scelerisque",
                    "tortor eros molestie tellus",
                    "pretium"
                ];
                const i = Math.round(Math.random() * 100) % strs.length;
                const words = strs[i];
                return {
                    jdata: {
                        words
                    }
                }
            },
        },
        { 
            ctype: "_arb_pp",
            categoryLabel: "Dummy Content", 
            label: "Paragraph", 
            createItem: () => ({}),
        },
        { 
            ctype: "_arb_pps",
            categoryLabel: "Dummy Content", 
            label: "Paragraphs",
            createItem: () => ({}),
        },
        { 
            ctype: "_menu",       
            categoryLabel: "Dummy Content", 
            label: "Menu",
            createItem: () => ({}),
        },
        { 
            ctype: "_arb_linechart1",
            categoryLabel: "Dummy Content", 
            label: "Line Chart",
            createItem: () => ({}),
        },
        {
            ctype: "dynamic-linechart1",
            categoryLabel: "Charts",
            label: "Line Chart",
            createItem: () => ({
                render: `<LineChart
                    data={data1}
                    margin={{
                        top: 20,
                        right: 30,
                        left: 20,
                        bottom: 20,
                    }}
                >
                    <CartesianGrid strokeDasharray=\"3 3\" />
                    <XAxis dataKey=\"name\" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Line type=\"monotone\" dataKey=\"pv\" stroke=\"#8884d8\" activeDot={{ r: 8 }} />
                    <Line type=\"monotone\" dataKey=\"uv\" stroke=\"#82ca9d\" />
                </LineChart>`
            })
        },
        { 
            ctype: "_arb_areachart1",
            categoryLabel: "Dummy Content", 
            label: "Area Chart",
            createItem: () => ({}),
        },
        { 
            ctype: "_arb_cchart1",
            categoryLabel: "Dummy Content", 
            label: "Composed Chart",
            createItem: () => ({}),
        },
        { 
            ctype: "_arb_zsunburst",
            categoryLabel: "Dummy Content", 
            label: "Zoomable Sunburst",
            createItem: () => ({}),
        },
        //{ id: "_mi",   categoryLabel: "Content", label: "Menu Item", generator: (p) => <ArbitraryMenuItem {...p} /> },
        { 
            ctype: "_btn",  
            categoryLabel: "Dummy Content", 
            label: "Button",
            createItem: () => ({}),
        },
        //{ id: "_md",   categoryLabel: "Content", label: "Markdown", generator: (p) => <Markdown1 {...p} /> },

        { 
            ctype: "flex",  
            categoryLabel: "Layout", 
            label: "HStack (Flex)",
            svgPath: "M0 0h4v16h-4zm1 1h2v14h-2zM6 0h4v16h-4zm1 1h2v14h-2zM12 0h4v16h-4zm1 1h2v14h-2z",
            createItem: () => ({
                style: { flexDirection: "row" }
            }),
        },
        { 
            ctype: "flex",  
            categoryLabel: "Layout", 
            label: "VStack (Flex)",
            svgPath: "M0 0v4h16v-4zm1 1v2h14v-2zM0 6v4h16v-4zm1 1v2h14v-2zM0 12v4h16v-4zm1 1v2h14v-2z",
            createItem: () => ({
                style: { flexDirection: "column" }
            }),
        },
        { 
            ctype: "tabcontrol",    
            categoryLabel: "Layout", 
            label: "Tab Control",
            svgPath: "M0 0v16h16v-13h-5v-3h-10zM1 4v11h14v-11h-14zM1 1v3h4v-3zM6 1v2h4v-2z",
            createItem: () => ({}),
        },
        { 
            ctype: "hdock",   
            categoryLabel: "Layout", 
            label: "HDock Layout",
            svgPath: "M0 0v16h16v-16h-16zM1 1h2v14h-2zM4 1h8v14h-8zM13 1h2v14h-2z",
            createItem: () => ({}),
        },
        { 
            ctype: "vdock",   
            categoryLabel: "Layout",
            label: "VDock Layout",
            svgPath: "M0 0v16h16v-16h-16zM1 1v2h14v-2zM1 4v8h14v-8zM1 13v2h14v-2z",
            createItem: () => ({}),
        },
        { 
            ctype: "vscroll", 
            categoryLabel: "Layout", 
            label: "VScroll",
            svgPath: "M0 0h16v16h-16zM1 1h11v14h-11zM13 1h2v1h-2zM13 8h2v5h-2zM13 14h2v1h-2z",
            createItem: () => ({}),
        },
        { 
            ctype: "vhscroll",
            categoryLabel: "Layout",
            label: "VHScroll",
            svgPath: "M0 0h16v16h-16zM1 1h11v11h-11zM13 1h2v1h-2zM13 6h2v6h-2zM1 13v2h1v-2zM6 13v2h6v-2zM13 13v2h2v-2z",
            createItem: () => ({}),
        },
        { 
            ctype: "div",
            categoryLabel: "Layout",
            label: "Div",
            //svgPath: "M0 0h4v16h-4zm1 1h2v14h-2zM6 0h4v16h-4zm1 1h2v14h-2zM12 0h4v16h-4zm1 1h2v14h-2z",
            createItem: () => ({}),
        },
        { 
            ctype: "configurator",
            categoryLabel: "Simulator",
            label: "Configurator",
            //svgPath: "M0 0h4v16h-4zm1 1h2v14h-2zM6 0h4v16h-4zm1 1h2v14h-2zM12 0h4v16h-4zm1 1h2v14h-2z",
            createItem: () => ({}),
        },
        { 
            ctype: "context-pipeline",
            categoryLabel: "Compute",
            desc_label: "Pipeline Compute Context",
            label: "Pipeline Context",
            createItem: () => ({}),
        },
        { 
            ctype: "context-js",
            categoryLabel: "Compute",
            desc_label: "Javascript Compute Context",
            label: "Js Context",
            createItem: () => ({}),
        },
        { 
            ctype: "btn-calc",
            categoryLabel: "Compute",
            label: "Compute Button",
            createItem: () => ({}),
        },
        { 
            ctype: "btn-copy-state",
            categoryLabel: "Compute",
            label: "Copy State Button",
            createItem: () => ({}),
        },
        { 
            ctype: "json-viewer",
            categoryLabel: "Compute",
            desc_label: "Compute Context Debug JSON",
            label: "Debug",
            createItem: () => ({}),
        },
        { 
            ctype: "data-table",
            categoryLabel: "Data",
            label: "Data Table",
            createItem: () => ({}),
        },
        {
            ctype: "custom-render",
            categoryLabel: "Dynamic Content",
            label: "Custom Render",
            createItem: () => ({})
        },
        {
            ctype: "bound-drop-down",
            categoryLabel: "Form",
            label: "Bound Dropdown",
            createItem: () => ({})
        },
        {
            ctype: "bound-toggle-button",
            categoryLabel: "Form",
            label: "Bound Toggle Button",
            createItem: () => ({})
        },
        {
            ctype: "select-cgroups",
            categoryLabel: "Form",
            label: "Select CGroups",
            createItem: () => ({})
        }


    ]
    return templates;
    
}